import {useState} from "react";
import DrugSearchText from './DrugSearchText';
import SectionStructure from '../../../../../components/Section/SectionStructure';
import DrugButtonGroup from "../ButtonGroup/DrugButtonGroup";
import { GetDrugSearchCard } from "./DrugSearch/GetDrugSearchCard";
import CardMarkerSmall from "../../../../../components/CockpitCards/CardMarkerSmall";
import PharmaDrugsSubText from "./DrugSearch/PharmaDrugsSubText"

import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import Badge, { badgeClasses } from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import DrugList from "./DrugSearch/Druglist";
import CustomDialogSmall from "../../../../../components/Dialog/DiaCompSmall";
import Grid from '@mui/material/Grid';


const CartBadge = styled(Badge)`
  & .${badgeClasses.badge} {
    top: -14px;
    right: -4px;
  }
`;


export default function SectionDrugSearch() {

const [dialogOpen, setdialogOpen] = useState(false);
const handleDialogOpen = () => {setdialogOpen(true);};
const handleDialogClose = () => {setdialogOpen(false);};
    
    return (
<>
    <SectionStructure
    
            sectiontext=    { <DrugSearchText /> }
            sectiondiagroup=    { <>
                    
                    <Grid container sx={{width: '100%'}}>
                        <Grid size={{xs:12}} sx={{mb:1, display:'flex', justifyContent:'center', alignItems:'flex-start'}}>     
                                <IconButton onClick={handleDialogOpen} > 
                                <InfoIcon sx={{fontSize: '160%', color: 'greydark.C900', '&:hover': { transition: 'transform 0.2s ease',  transform: 'scale(1.2)',} }}/> 
                                <CartBadge badgeContent={184} max={999} color="warning" overlap="circular" />
                            </IconButton>
                        </Grid>
                       
                        <Grid size={{xs:12}} sx={{display:'flex', justifyContent:'center', alignItems:'flex-start' }}> <DrugButtonGroup /> </Grid>
                    </Grid>

                 </>} 

            sectioncards=  {<>

                <CardMarkerSmall
            
                    headline = "Medication Search"
                    subtext = {<PharmaDrugsSubText /> }
                    
                    cardlines = {<GetDrugSearchCard />}
                 />
        </>}
    />

        <CustomDialogSmall open={dialogOpen} onClose={handleDialogClose}
       
                  title={"PGx - Covered Drugs"}
                  content = {<DrugList />}
          />


</>
)
}